import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Cpu, HardDrive, Database, Globe, Radio, MapPin, Shield, ShieldEllipsis, ShieldEllipsisIcon, HardDriveIcon, MemoryStick, UsersRound, HeartPlusIcon, DatabaseBackupIcon, LifeBuoyIcon } from 'lucide-react';
import './discord.css';

interface PlanFeature {
  icon: React.ElementType;
  label: string;
  value: string;
}

interface PricingPlan {
  id: string;
  name: string;
  color: string;
  features: PlanFeature[];
  basePrice: number;
  popular?: boolean;
  orderLink: string;
}

interface PricingPeriod {
  id: string;
  label: string;
  months: number;
  discount: number;
  badge?: string;
}

// Composants SVG pour les mobs Minecraft
const Discord = () => (
    <svg width="60" height="60" viewBox="0 0 90 90" fill="none" className="Discord-logo-icon">

      <path
          d="M60.1045 13.8978C55.5792 11.8214 50.7265 10.2916 45.6527 9.41542C45.5603 9.39851 45.468 9.44077 45.4204 9.52529C44.7963 10.6353 44.105 12.0834 43.6209 13.2216C38.1637 12.4046 32.7345 12.4046 27.3892 13.2216C26.905 12.0581 26.1886 10.6353 25.5617 9.52529C25.5141 9.44359 25.4218 9.40133 25.3294 9.41542C20.2584 10.2888 15.4057 11.8186 10.8776 13.8978C10.8384 13.9147 10.8048 13.9429 10.7825 13.9795C1.57795 27.7309 -0.943561 41.1443 0.293408 54.3914C0.299005 54.4562 0.335386 54.5182 0.385761 54.5576C6.45866 59.0174 12.3413 61.7249 18.1147 63.5195C18.2071 63.5477 18.305 63.5139 18.3638 63.4378C19.7295 61.5728 20.9469 59.6063 21.9907 57.5383C22.0523 57.4172 21.9935 57.2735 21.8676 57.2256C19.9366 56.4931 18.0979 55.6 16.3292 54.5858C16.1893 54.5041 16.1781 54.304 16.3068 54.2082C16.679 53.9293 17.0513 53.6391 17.4067 53.3461C17.471 53.2926 17.5606 53.2813 17.6362 53.3151C29.2558 58.6202 41.8354 58.6202 53.3179 53.3151C53.3935 53.2785 53.4831 53.2898 53.5502 53.3433C53.9057 53.6363 54.2779 53.9293 54.6529 54.2082C54.7816 54.304 54.7732 54.5041 54.6333 54.5858C52.8646 55.6197 51.0259 56.4931 49.0921 57.2228C48.9662 57.2707 48.9102 57.4172 48.9718 57.5383C50.038 59.6034 51.2554 61.5699 52.5959 63.435C52.6519 63.5139 52.7526 63.5477 52.845 63.5195C58.6464 61.7249 64.529 59.0174 70.6019 54.5576C70.6551 54.5182 70.6887 54.459 70.6943 54.3942C72.1747 39.0791 68.2147 25.7757 60.1968 13.9823C60.1772 13.9429 60.1437 13.9147 60.1045 13.8978ZM23.7259 46.3253C20.2276 46.3253 17.3451 43.1136 17.3451 39.1693C17.3451 35.225 20.1717 32.0133 23.7259 32.0133C27.308 32.0133 30.1626 35.2532 30.1066 39.1693C30.1066 43.1136 27.28 46.3253 23.7259 46.3253ZM47.3178 46.3253C43.8196 46.3253 40.9371 43.1136 40.9371 39.1693C40.9371 35.225 43.7636 32.0133 47.3178 32.0133C50.9 32.0133 53.7545 35.2532 53.6986 39.1693C53.6986 43.1136 50.9 46.3253 47.3178 46.3253Z"
          fill="#fff"
      />
    </svg>
);

const ZombieIcon = () => (
    <svg width="60" height="60" viewBox="0 0 116 116" fill="none" className="mob-icon">
      <g clipPath="url(#clip_zombie)">
        <path d="M58 0L30 15L58 30L86 15L58 0ZM25 45L35 50V80L25 75V45ZM91 45V75L81 80V50L91 45ZM40 55V85L58 95L76 85V55L58 65L40 55ZM20 85L30 90V110L20 105V85ZM96 85V105L86 110V90L96 85ZM35 95V115L58 105L81 115V95L58 100L35 95Z"
              fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="clip_zombie">
          <rect width="116" height="116"/>
        </clipPath>
      </defs>
    </svg>
);

const BlazeIcon = () => (
    <svg width="60" height="60" viewBox="0 0 116 116" fill="none" className="mob-icon">
      <g clipPath="url(#clip_blaze)">
        <path d="M58 10L48 20L58 30L68 20L58 10ZM40 25L30 35L40 45L50 35L40 25ZM76 25L86 35L76 45L66 35L76 25ZM58 40L48 50L58 60L68 50L58 40ZM25 45L15 55L25 65L35 55L25 45ZM91 45L101 55L91 65L81 55L91 45ZM40 70L30 80L40 90L50 80L40 70ZM76 70L86 80L76 90L66 80L76 70ZM58 85L48 95L58 105L68 95L58 85Z"
              fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="clip_blaze">
          <rect width="116" height="116"/>
        </clipPath>
      </defs>
    </svg>
);

const SpiderIcon = () => (
    <svg width="60" height="60" viewBox="0 0 116 116" fill="none" className="mob-icon">
      <g clipPath="url(#clip_spider)">
        <path d="M58 30C70 30 80 40 80 52C80 64 70 74 58 74C46 74 36 64 36 52C36 40 46 30 58 30ZM25 45L15 35L10 40L20 50L25 45ZM91 45L96 40L106 35L101 45L91 45ZM20 52L10 47L5 52L15 57L20 52ZM96 52L101 57L111 52L106 47L96 52ZM25 59L20 64L10 74L15 79L25 69L25 59ZM91 59L91 69L101 79L106 74L96 64L91 59Z"
              fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="clip_spider">
          <rect width="116" height="116"/>
        </clipPath>
      </defs>
    </svg>
);

const EnderIcon = () => (
    <svg width="60" height="60" viewBox="0 0 116 116" fill="none" className="mob-icon">
      <g clipPath="url(#clip_ender)">
        <path d="M58 5L45 15L58 25L71 15L58 5ZM35 20L22 30L35 40L48 30L35 20ZM81 20L94 30L81 40L68 30L81 20ZM58 35L45 45L58 55L71 45L58 35ZM22 50L9 60L22 70L35 60L22 50ZM94 50L107 60L94 70L81 60L94 50ZM45 65L32 75L45 85L58 75L45 65ZM71 65L84 75L71 85L58 75L71 65ZM58 95L45 105L58 115L71 105L58 95Z"
              fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="clip_ender">
          <rect width="116" height="116"/>
        </clipPath>
      </defs>
    </svg>
);

const Price: React.FC = () => {
  const [selectedPeriod, setSelectedPeriod] = useState('monthly');

  const periods: PricingPeriod[] = [
    { id: 'monthly', label: 'Par mois', months: 1, discount: 0 },
    { id: '3months', label: '3 mois', months: 3, discount: 0, badge: '-5%' },
    { id: '6months', label: '6 mois', months: 6, discount: 0, badge: '-5%' },
    { id: '1year', label: '1 an', months: 12, discount: 0, badge: '-5%' }
  ];

  const plans: PricingPlan[] = [
    {
      id: 'Dev',
      name: 'Bot-Discord | Dev',
      color: 'green',
      basePrice: 0.99,
      orderLink: 'https://client.hostware.fr/store/basket/add/19',
      features: [
        { icon: Cpu, label: 'CPU', value: '1 vCPU' },
        { icon: MemoryStick, label: 'RAM', value: ' 1 Go RAM' },
        { icon: HardDriveIcon, label: '', value: '500 Mo de stockage' },
        { icon: Radio, label: 'Bande passante', value: ' 10 Gbps' },
        { icon: LifeBuoyIcon, label: 'Support prioritaire', value: '' },
        { icon: ShieldEllipsisIcon, label: 'Protection Anti-DDos', value: 'Protection' }
      ]
    },
    {
      id: 'Starter',
      name: 'Bot-Discord | Starter',
      color: 'blue',
      basePrice: 1.99,
      popular: true,
      orderLink: 'https://client.hostware.fr/store/basket/add/20',
      features: [
        { icon: Cpu, label: 'CPU', value: '2 vCPU' },
        { icon: MemoryStick, label: 'RAM', value: ' 2 Go RAM' },
        { icon: HardDriveIcon, label: '', value: '5 Go de stockage' },
        { icon: Radio, label: 'Bande passante', value: ' 10 Gbps' },
        { icon: LifeBuoyIcon, label: 'Support prioritaire', value: '' },
        { icon: ShieldEllipsisIcon, label: 'Protection Anti-DDos', value: 'Protection' }
      ]
    },
    {
      id: 'Lite',
      name: 'Bot-Discord | Lite',
      color: 'yellow',
      basePrice: 2.55,
      orderLink: 'https://client.hostware.fr/store/basket/add/21',
      features: [
        { icon: Cpu, label: 'CPU', value: '3 vCPU' },
        { icon: MemoryStick, label: 'RAM', value: ' 4 Go RAM' },
        { icon: HardDriveIcon, label: '', value: '10 Go de stockage' },
        { icon: Radio, label: 'Bande passante', value: ' 10 Gbps' },
        { icon: LifeBuoyIcon, label: 'Support prioritaire', value: '' },
        { icon: ShieldEllipsisIcon, label: 'Protection Anti-DDos', value: 'Protection' }
      ]
    },
  ];

  const getMobIcon = (planId: string) => {
    switch (planId) {
      case 'Discord': return <Discord  />;
      case 'zombie': return <ZombieIcon />;
      case 'blaze': return <BlazeIcon />;
      case 'spider': return <SpiderIcon />;
      case 'ender': return <EnderIcon />;
      default: return <Discord  />;
    }
  };

  const calculatePrice = (basePrice: number, selectedPeriodId: string, planId: string) => {
    const period = periods.find(p => p.id === selectedPeriodId);
    if (!period) return { price: basePrice, total: basePrice, savings: 0 };

    // Appliquer 5% de réduction uniquement sur Lite et Premium pour 3m/6m/1an
    const eligible = planId === 'Lite' || planId === 'Starter';
    const discount = (period.id !== 'monthly' && eligible) ? 5 : 0;

    const discountedPrice = basePrice * (1 - discount / 100);
    const totalPrice = discountedPrice * period.months;

    return {
      price: discountedPrice,
      total: totalPrice,
      savings: (period.months > 1 && discount > 0) ? (basePrice * period.months - totalPrice) : 0
    };
  };

  const getSelectedPeriod = () => periods.find(p => p.id === selectedPeriod);

  return (
      <>
        <Helmet>
          <title>Hébergement Discord Bot Node.js & Python - HostWare</title>
          <meta name="description" content="content=Louez un hébergement stable à partir de 0.99 € /mois pour vos bots Discord en Node.js ou Python avec HostWare. Performances, sécurité, et flexibilité au meilleur prix."/>
          <meta name="keywords" content="hébergement minecraft, serveur fivem, vps gaming, gmod, novalife, serveur jeu, hébergement pas cher" />
          <meta name="title" content="Serveur Discord Bot performant - HostWare" />

          {/* Open Graph / Facebook */}
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="HostWare" />
          <meta property="og:locale" content="fr_FR" />
          <meta property="og:url" content="https://hostware.fr/discord" />
          <meta property="og:title" content="Serveurs Discord Bot - HostWare" />
          <meta property="og:description" content="Hébergement optimisé à partir de 0.50 € /mois pour bots Discord Node.js & Python avec bases de données, Anti-DDoS et support 24/7." />
          <meta property="og:image" content="https://hostware.fr/logo512.png" />

          {/* Twitter */}
          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:title" content="Serveur Discord Bot performant - HostWare" />
          <meta property="twitter:description" content="Hébergement optimisé à partir de 0.50 € /mois pour bots Discord Node.js & Python avec bases de données, Anti-DDoS et support 24/7." />
          <meta property="twitter:image" content="https://hostware.fr/logo512.png" />
          <meta property="twitter:image:width" content="512" />
          <meta property="twitter:image:height" content="512" />
          <meta property="twitter:image:alt" content="Logo HostWare" />
        </Helmet>

        <div className="pricing-container">
          {/* Background Effects */}
          <div className="background-overlay"></div>
          <div className="background-orb orb-1"></div>
          <div className="background-orb orb-2"></div>
          <div className="floating-particles"></div>

          {/* Hero Section */}
          <div className="hero-section">
            <div className="hero-content">
              <div className="rocket-icon animate-bounce-slow">🚀</div>
              <h1 className="hero-title animate-fade-in-up">
                DÉCOUVREZ NOS OFFRES
              </h1>
              <p className="hero-subtitle animate-fade-in-up" style={{animationDelay: '0.2s'}}>
                Louez votre serveur Nova Life : abmoise pour jouer avec vos amis ou en communauté. Profitez de performances exceptionnelles pour une expérience de jeu inoubliable.
              </p>

              {/* Duration Tabs */}
              <div className="duration-tabs animate-fade-in-up" style={{animationDelay: '0.4s'}}>
                {periods.map((period) => (
                    <button
                        key={period.id}
                        onClick={() => setSelectedPeriod(period.id)}
                        className={`duration-tab ${selectedPeriod === period.id ? 'active' : ''}`}
                    >
                      {period.label}
                      {period.badge && (
                          <span className="discount-badge animate-pulse-soft">
                      {period.badge}
                    </span>
                      )}
                    </button>
                ))}
              </div>
            </div>
          </div>

          {/* Pricing Cards */}
          <div className="pricing-section">
            <div className="plans-grid">
              {plans.map((plan, index) => {
                const pricing = calculatePrice(plan.basePrice, selectedPeriod, plan.id);
                const currentPeriod = getSelectedPeriod();

                return (
                    <div
                        key={plan.id}
                        className={`plan-card ${plan.color} ${plan.popular ? 'popular' : ''} animate-fade-in-up`}
                        style={{animationDelay: `${0.1 * index}s`}}
                    >
                      {plan.popular && (
                          <div className="popular-badge animate-glow">
                            Populaire
                          </div>
                      )}

                      {/* Plan Header */}
                      <div className="plan-header">
                        <div className="plan-icon-container">
                          <Discord /> {/* Affiche toujours Discord */}
                        </div>
                        <h3 className="plan-name">{plan.name}</h3>
                      </div>

                      {/* Features */}
                      <div className="plan-features">
                        {plan.features.map((feature, featureIndex) => (
                            <div
                                key={featureIndex}
                                className="feature-row animate-slide-in-left"
                                style={{animationDelay: `${0.6 + featureIndex * 0.1}s`}}
                            >
                              <feature.icon className="feature-icon" size={16} />
                              <span className="feature-label">{feature.label}</span>
                              <span className="feature-value">{feature.value}</span>
                            </div>
                        ))}
                      </div>

                      {/* Pricing */}
                      <div className="plan-pricing">
                        <div className="price-display">
                          <div className="price animate-number-change">
                            {pricing.price.toFixed(2)} €
                          </div>
                          <div className="duration">{currentPeriod?.label}</div>
                        </div>

                        {currentPeriod && currentPeriod.months > 1 && (
                            <div className="pricing-details">
                              <div className="total-price">
                                Total: {pricing.total.toFixed(2)} €
                              </div>
                              {pricing.savings > 0 && (
                                  <div className="savings animate-pulse-soft">
                                    Économie: {pricing.savings.toFixed(2)} €
                                  </div>
                              )}
                            </div>
                        )}
                      </div>

                      {/* CTA Button */}
                      <a
                          href={plan.orderLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="plan-button animate-button-hover"
                      >
                        <span>Commander</span>
                        <div className="button-shine"></div>
                      </a>
                    </div>
                );
              })}
            </div>
          </div>
        </div>
      </>
  );
};

export default Price;